export default class ChatConstants {
  static typingStatusTimeout = 10000;
  static draftStorageKeyEdit = 'draftMessagesEdit';
  static draftStorageKeyPublished = 'draftMessagesPublished';
}
